import * as React from "react";
import IframeResizer from "iframe-resizer-react";
import Logo from "./logo";

const Embed = ({ url }) => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [isAnimating, setIsAnimating] = React.useState(true);
  const [progress, setProgress] = React.useState(0);
  const iframeEl = React.useRef(null);

  React.useEffect(() => {
    // Start progress (fake crawl to 90%)
    const timer = setTimeout(() => setProgress(90), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleResized = () => {
    setIsLoaded(true);
    setProgress(100);
  };

  const handleTransitionEnd = () => {
    if (progress === 100) {
      setIsAnimating(false);
    }
  };

  return (
    <div
      className="embed"
      aria-live="polite"
      aria-atomic="true"
      aria-busy={!isLoaded || isAnimating}
    >
      {(!isLoaded || isAnimating) && (
        <div className="embed-loading" aria-hidden="true">
          <Logo icon />
          <div
            className="embed-loading-bar"
            style={{
              "--embed-loading-width": `${progress}%`,
              "--embed-loading-transition":
                progress === 100
                  ? "width 0.4s ease-out"
                  : "width 15s cubic-bezier(0.1, 0, 0, 1)",
            }}
            onTransitionEnd={handleTransitionEnd}
          />
        </div>
      )}
      <IframeResizer
        className={
          isLoaded && !isAnimating ? "embed-iframe" : "visually-hidden"
        }
        forwardRef={iframeEl}
        src={url}
        onResized={handleResized}
      />
    </div>
  );
};

export default Embed;
